import { ApplicantCustomQuestionAnswerV2Dto } from '@inosio/payments-sdk';
import { ApplicantEntityDataTableField } from './ApplicationDetailsApplicantEntityData';

/**
 * Given cutom questions for any entity it returns them in a tabular form along with their child question
 * @param customQuestionsAnswers
 * @returns
 */
export const handleBuildCustomQuestionDataTable = (customQuestionsAnswers: ApplicantCustomQuestionAnswerV2Dto[]) => {
  const customQuestionsForThisEntity: ApplicantEntityDataTableField[] = [];

  customQuestionsAnswers
    ?.filter((cq) => !cq.ParentQuestionUuid)
    .forEach((cq) => {
      // Process parent question
      customQuestionsForThisEntity.push({
        label: cq.QuestionText,
        value: cq.ResponseType === 'Boolean' ? (Boolean(cq.Response) ? 'Yes' : 'No') : cq.Response ? String(cq.Response) : cq.Response ? String(cq.Response) : '(left blank)',
      });

      // Find and process child questions immediately after the parent
      const childQuestions = customQuestionsAnswers?.filter((ccq) => ccq.ParentQuestionUuid === cq.QuestionUuid);
      childQuestions?.forEach((ccq) => {
        customQuestionsForThisEntity.push({
          label: `↳ ${ccq.QuestionText}`, // Adding an arrow and some indent to show it's a child question
          paddingLeft: '10px',
          value: ccq.ResponseType === 'Boolean' ? (Boolean(ccq.Response) ? 'Yes' : 'No') : ccq.Response ? String(ccq.Response) : cq.Response ? String(cq.Response) : '(left blank)',
        });
      });
    });

  return customQuestionsForThisEntity;
};
